<template>
<div class="chapter">
<div class="inner_page">
<div class="pgbreak" epub:type="pagebreak" id="page_vii" title="vii">
<h2 class="FMO">Contents</h2>
<p class="TOC-FM"><a href="#/xhtml/Ack">Acknowledgments</a></p>
<p class="TOC-CT"><a href="#/xhtml/01_Ilany_Intro">Introduction</a></p>
<p class="TOC-CT"><span href="#/xhtml/02_Ilany_Ch01" title="Link target outside of Sample"><span class="space">1</span>Troglodytes, Hottentots, and Hebrews: The Bible and the Sources of German Anthropology</span></p>
<p class="TOC-CT"><span href="#/xhtml/03_Ilany_Ch02" title="Link target outside of Sample"><span class="space">2</span>The Law and the People: Mosaic Law and the German Enlightenment</span></p>
<p class="TOC-CT"><span href="#/xhtml/04_Ilany_Ch03" title="Link target outside of Sample"><span class="space">3</span>The Eighteenth-Century Polemic on the Extermination of the Canaanites</span></p>
<p class="TOC-CT"><span href="#/xhtml/05_Ilany_Ch04" title="Link target outside of Sample"><span class="space">4</span>“Is Judah Indeed the Teutonic Fatherland?” The Hebrew Model and the Birth of German National Culture</span></p>
<p class="TOC-CT"><span href="#/xhtml/06_Ilany_Ch05" title="Link target outside of Sample"><span class="space">5</span>“Lovers of Hebrew Poetry”: The Battle over the Bible’s Relevance at the Turn of the Nineteenth Century</span></p>
<p class="TOC-CT"><span href="#/xhtml/07_Ilany_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="TOC-BM-f"><span href="#/xhtml/08_Ilany_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC-BM"><span href="#/xhtml/Ilany_Index" title="Link target outside of Sample">Index</span></p>
<div class="pgbreak" epub:type="pagebreak" id="page_viii" title="viii">
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0161011b